export default __webpack_public_path__ + "static/media/portfolio-170.727aac25.jpg";